import BlankPage from "@/layout/Blank.vue";
import DefaultPage from "@/layout/Default.vue";
import ChangeCity from "@/page/ChangeCity.vue";
import GoodsList from "@/page/GoodsList.vue";
import Index from "@/page/index.vue";
import Login from "@/page/Login.vue";
import Register from "@/page/Register.vue";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  // mode: 'hash',
  // mode: "history",
  routes: [
    {
      path: "/",
      name: "default",
      component: DefaultPage,
      redirect: "/index.html",
      children: [
        {
          path: "s/:name",
          name: "goods",
          component: GoodsList,
        },
        {
          path: "/index.html",
          name: "index",
          component: Index,
        },
        {
          path: "/changeCity",
          name: "changeCity",
          component: ChangeCity,
        },
      ],
    },
    {
      path: "/blank",
      name: "blank",
      component: BlankPage,
      children: [
        {
          path: "login",
          name: "login",
          component: Login,
        },
        {
          path: "register",
          name: "register",
          component: Register,
        },
      ],
    },
  ],
});
